import {
  Injectable, Output, EventEmitter
} from '@angular/core'
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class TabOpenService {
  TabInfo = new EventEmitter(null);
  ReplaceTabEvent = new EventEmitter(null);
  DestroyTabEvent = new EventEmitter(null);
  ConfirmDestroyTabEvent = <any>new EventEmitter(null);
  UnsavedChangedDetected = new EventEmitter(null);
  destroyModalEvent = new EventEmitter(null);
  routeToParentEvent = new EventEmitter(null);
  updateTabNameEvent = new EventEmitter(null);
  alertPopupEvent = new EventEmitter(null);
  focusTabEvent = new EventEmitter(null);
  ChangeComponentEvent = new EventEmitter(null);
  public TabOpenEvent = this.TabInfo.asObservable();
  constructor() {

  }
  OpenTab(data: any) {
    this.TabInfo.emit(data);
    // localStorage.setItem["OrderData"]=data;
  }
  ConfirmDestroyTab(data: any) {
    this.ConfirmDestroyTabEvent.emit(data);
    // localStorage.setItem["OrderData"]=data;
  }
  destroyModal(data: any) {
    this.destroyModalEvent.emit(data);
    // localStorage.setItem["OrderData"]=data;
  }
  routeToParent(data: any) {
    this.routeToParentEvent.emit(data);
    // localStorage.setItem["OrderData"]=data;
  }
  ReplaceTab(data: {
    CurrentTabIndex: number, newTabInfo: {
      tabId: number,
      params: any,
      tabTitle: string
    }
  }, checkDirty = true) {
    this.ReplaceTabEvent.emit({ data: data, checkDirty: checkDirty });
    // localStorage.setItem["OrderData"]=data;
  }
  DestroyTab(tabCounter: number, type = "tab") {
    this.DestroyTabEvent.emit({ tabCounter: tabCounter, type: type });
  }

  unsavedChangedDetected(data) {
    this.UnsavedChangedDetected.emit({ data: data });
  }
  updateTabName(data) {
    this.updateTabNameEvent.emit({ data: data });
  }
  alertPopup(data) {
    this.alertPopupEvent.emit({ data: data });
  }
  focusTab(tabCounter,previousTabCounter) {
    this.focusTabEvent.emit({ tabCounter: tabCounter, previoustabCounter : previousTabCounter });
  }
  ChangeComponent(data) {
    this.ChangeComponentEvent.emit({ data: data });
  }
}